export enum UserCertificationProgressStatus {
    inititialized = 'init',
    inProgress = 'in-progress',
    completed = 'completed',
}
